// extracted by mini-css-extract-plugin
export default {"wrapper":"Profile_wrapper__kw1Hj","fromParams":"Profile_fromParams__o7pYO","buttonStyle":"Profile_buttonStyle__rizoA"};